import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { tokenManager } from "services/client/token-manager";

/**
 * Route-level protection: requires refresh token (session). If missing, redirect to login.
 * API level handles access token (refetch via refresh); refresh expiry triggers logout (session expired).
 */
export default function ProtectedRoute({ children }) {
  const refreshToken = tokenManager.getRefresh();
  const location = useLocation();
  if (!refreshToken) {
    localStorage.removeItem("searchBarKeyStorage");
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }
  return children;
}
